<template>
  <Modal
    event-tracking-source="remove team member popup"
    class="remove-from-team-modal"
    :hasClose="true"
    @close="$emit('close')"
  >
    <h2
      slot="header"
      class="text-ma-black-1 text-center text-xl m-3 font-semibold"
    >
      Remove Members?
    </h2>

    <p class="m-auto w-full text-ma-gray-3 text-base mb-4 text-center max-w-md">
      The team slot will remain active. A new member can be added to this slot
      at no additional cost through this billing cycle.
    </p>

    <div slot="footer">
      <div class="mx-auto mb-3 flex justify-center w-full max-w-md">
        <button
          @click="$emit('close')"
          class="cursor-pointer inline-block w-32 mr-4 md:w-40 font-semibold text-center btn btn--purple-outline text-base py-2"
        >
          <template v-if="loading">
            Close
          </template>
          <template v-else>
            Cancel
          </template>
        </button>
        <button
          @click="$emit('confirm')"
          :disabled="loading"
          class="cursor-pointer inline-block w-32 md:w-40 font-semibold text-center btn btn--primary text-white text-base py-2"
        >
          <template v-if="loading">
            <div class="animation-spin btn-spinner inline-block ml-1" v-cloak>
              <i class="icon--spinner2"></i>
            </div>
            Removing ...
          </template>
          <template v-else>
            Confirm
          </template>
        </button>
      </div>
    </div>
  </Modal>
</template>

<script>
import Modal from "@/components/Modal";

export default {
  components: {
    Modal,
  },
  props: {
    loading: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
};
</script>

<style>
.remove-from-team-modal .modal-container {
  width: 90%;
  max-width: 900px;
}
</style>
